module.exports = __webpack_public_path__ + "img/fi_x-circle.79bd49e6.svg";